import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const getSuppliesConfigCreationInfo = {
  name: "getSuppliesConfigCreationInfo" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    suppliesProductId: productIdFormat.schema.nullish(),
  }),
  output: z.object({
    hasLabelPaperConfigAtLocation: z.boolean(),
    hasConfigForProductAtLocation: z.boolean(),
  }),
};
